import React, {Component, createRef} from 'react';
// import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
import GlobalVariable from "../../GlobalVariable";
import api, { refreshRolesJwt as refreshRolesJwtRequest } from "../../api";

import Menu from "../Menu";
import Preloader from "../Preloader";
import './ProfileChange.scss';

type AnyObj = any;

// =====================
// типы для ролей
// =====================
interface UserRole {
    code: string;
    name: string;
    hasRole: boolean;
}

interface RolesResponse {
    roles: string[];
}

// =====================
// helper: человекочитаемое имя роли
// =====================
const KNOWN_ROLE_CODES = [
    "ROLE_USER",
    "ROLE_CLIENT",
    "ROLE_STAFF",
    "ROLE_MANAGER",
    "ROLE_FR",
    "ROLE_FRANCHISEE",
    "ROLE_YK",
    "ROLE_SPECIALIST",
    "ROLE_SPECIALIST_TS",
    "ROLE_DESIGN",
    "ROLE_SUPPORT",
    "ROLE_ADMIN",
    "ROLE_SUPER_ADMIN",
    "ROLE_EXTERNAL_CASHBOX",
] as const;

const CLIENT_ROLE_CODES = ["ROLE_USER", "ROLE_CLIENT"];
const CURRENT_APP_ROLE_CODES = ["ROLE_STAFF"];
const LKFR_ROLE_CODES = ["ROLE_FR", "ROLE_FRANCHISEE"];
const SUPPORT_ROLE_CODES = [
    "ROLE_MANAGER",
    "ROLE_SPECIALIST",
    "ROLE_SPECIALIST_TS",
    "ROLE_DESIGN",
    "ROLE_SUPPORT",
    "ROLE_ADMIN",
    "ROLE_SUPER_ADMIN",
    "ROLE_YK",
    "ROLE_EXTERNAL_CASHBOX",
];
const CURRENT_APP_ACTION_CODE = "__CURRENT_APP__";
const CURRENT_APP_STAY_LABEL = "Остаться в кабинете сотрудников";

function getRoleDisplayName(roleCode: string): string {
    const roleMap: Record<string, string> = {
        ROLE_USER: "Клиент",
        ROLE_CLIENT: "Клиент",
        ROLE_STAFF: "Мастер",
        ROLE_MANAGER: "Менеджер",
        ROLE_FR: "Франчайзи",
        ROLE_FRANCHISEE: "Франчайзи",
        ROLE_YK: "УК",
        ROLE_SPECIALIST: "Специалист",
        ROLE_SPECIALIST_TS: "Сотрудник Тех. Поддержки",
        ROLE_DESIGN: "Дизайнер",
        ROLE_SUPPORT: "Поддержка",
        ROLE_ADMIN: "Администратор",
        ROLE_SUPER_ADMIN: "Супер администратор",
        ROLE_EXTERNAL_CASHBOX: "Внешняя касса",
    };
    return roleMap[roleCode] || roleCode;
}

function buildRoleList(rolesFromApi: string[]): UserRole[] {
    const normalizedRoles = Array.isArray(rolesFromApi)
        ? Array.from(new Set(rolesFromApi.map((role) => String(role))))
        : [];

    const knownRoles = KNOWN_ROLE_CODES.map((code) => ({
        code,
        name: getRoleDisplayName(code),
        hasRole: normalizedRoles.includes(code),
    }));

    const unknownRoles = normalizedRoles
        .filter((code) => !KNOWN_ROLE_CODES.includes(code as (typeof KNOWN_ROLE_CODES)[number]))
        .map((code) => ({
            code,
            name: getRoleDisplayName(code),
            hasRole: true,
        }));

    return [...knownRoles, ...unknownRoles];
}

function trimTrailingSlash(value: string | undefined | null): string {
    return String(value || "").trim().replace(/\/$/, "");
}

type AppTargets = {
    client: string;
    staff: string;
    lkfr: string;
    support: string;
};

function getFallbackTargets(): AppTargets {
    if (typeof window === "undefined") {
        return {
            client: "/",
            staff: "/",
            lkfr: "/",
            support: "/",
        };
    }

    const protocol = window.location.protocol === "http:" ? "http:" : "https:";
    const host = window.location.hostname.toLowerCase();
    const currentOrigin = trimTrailingSlash(window.location.origin) || "/";

    if (host.endsWith(".devchio.ru")) {
        return {
            client: `${protocol}//widget.devchio.ru`,
            staff: `${protocol}//staff.devchio.ru`,
            lkfr: `${protocol}//lkfr.devchio.ru`,
            support: `${protocol}//support.devchio.ru`,
        };
    }

    if (host.endsWith(".chio-chio.ru")) {
        return {
            client: `${protocol}//widget2.chio-chio.ru`,
            staff: `${protocol}//staff.chio-chio.ru`,
            lkfr: `${protocol}//lkfr.chio-chio.ru`,
            support: `${protocol}//designfront.chio-chio.ru`,
        };
    }

    return {
        client: currentOrigin,
        staff: currentOrigin,
        lkfr: currentOrigin,
        support: currentOrigin,
    };
}

function getAppTargets(): AppTargets {
    const fallbackTargets = getFallbackTargets();

    return {
        client: trimTrailingSlash(process.env.REACT_APP_CLIENT_HOME_URL) || fallbackTargets.client,
        staff: trimTrailingSlash(process.env.REACT_APP_STAFF_HOME_URL) || fallbackTargets.staff,
        lkfr: trimTrailingSlash(process.env.REACT_APP_LKFR_HOME_URL) || fallbackTargets.lkfr,
        support: trimTrailingSlash(process.env.REACT_APP_SUPPORT_HOME_URL) || fallbackTargets.support,
    };
}

function resolveRoleTarget(roleCode: string, appTargets: AppTargets): string {
    if (roleCode === CURRENT_APP_ACTION_CODE) return appTargets.staff;
    if (CLIENT_ROLE_CODES.includes(roleCode)) return appTargets.client;
    if (CURRENT_APP_ROLE_CODES.includes(roleCode)) return appTargets.staff;
    if (LKFR_ROLE_CODES.includes(roleCode)) return appTargets.lkfr;
    if (SUPPORT_ROLE_CODES.includes(roleCode)) return appTargets.support;
    return appTargets.client;
}

export class ProfileChange extends Component<AnyObj, AnyObj> {
    private fileInputRef = createRef<HTMLInputElement>();

    constructor(props: AnyObj) {
        super(props); window.scrollTo(0, 0);
        this.state = {
            name: '',
            date: '',
            email: '',
            genderM: false,
            genderG: false,
            isLoad: false,
            auth: false,
            openExit: false,
            openChangePoint: false,
            avatarUrl: '',
            avatarPreviewUrl: '',
            avatarFile: null as File | null,
            avatarUploading: false,
            avatarProgress: 0,
            avatarError: '',
            info: null as AnyObj | null,

            // роли
            userRoles: [] as UserRole[],
            rolesLoading: false,
            rolesRefreshing: false,
            isRoleModalOpen: false,
            mobileProfile: null as AnyObj | null,
            rating: null as AnyObj | null,
            serviceRequestText: '',
            serviceRequestSuccess: '',
            activeSheet: '',
            profileSaveSuccess: '',
            profileSaveError: '',
            profileLoadError: '',
        };

        this.changeName = this.changeName.bind(this);
        this.changeDate = this.changeDate.bind(this);
        this.changeEmail = this.changeEmail.bind(this);
        this.changeGenderM = this.changeGenderM.bind(this);
        this.changeGenderG = this.changeGenderG.bind(this);
        this.openDelBlock = this.openDelBlock.bind(this);
        this.onAvatarSelect = this.onAvatarSelect.bind(this);
        this.uploadAvatar = this.uploadAvatar.bind(this);
        this.removeAvatar = this.removeAvatar.bind(this);

        // биндим логику ролей
        this.fetchUserRoles = this.fetchUserRoles.bind(this);
        this.handleRefreshRoles = this.handleRefreshRoles.bind(this);
        this.handleRoleSelect = this.handleRoleSelect.bind(this);
        this.openRoleModal = this.openRoleModal.bind(this);
        this.closeRoleModal = this.closeRoleModal.bind(this);
    }

    changeGenderG(event: AnyObj) {
        const target = event.target;
        if (target.checked === true) {
            this.setState({ genderM: false, genderG: true });
        } else {
            this.setState({ genderM: false, genderG: false });
        }
    }
    changeGenderM(event: AnyObj) {
        const target = event.target;
        if (target.checked === true) {
            this.setState({ genderM: true, genderG: false });
        } else {
            this.setState({ genderM: false, genderG: true });
        }
    }

    changeName(event: AnyObj) { this.setState({ name: event.target.value }); }
    changeDate(event: AnyObj) { this.setState({ date: event.target.value }); }
    changeEmail(event: AnyObj) { this.setState({ email: event.target.value }); }

    renderButton() {
        let gender = this.state.genderM || this.state.genderG;
        const enabled = this.state.name && this.state.date && gender;
        if (enabled) {
            return (
                <div className='d-flex justify-content-center mt-3 mb-5'>
                    <div onClick={() => this.sender()}
                         className='p-3 bg-red chio-card d-inline-block white-text'>Сохранить</div>
                </div>
            );
        }
        return (
            <div className='d-flex justify-content-center mt-3 mb-5'>
                <div className='p-3 bg-red chio-card d-inline-block white-text' style={{opacity: .5, pointerEvents: 'none'}}>Сохранить</div>
            </div>
        );
    }

    sender() {
        const data = {
            name: this.state.name,
            date: this.state.date,
            email: this.state.email,
            genderM: this.state.genderM,
            genderG: this.state.genderG,
        };
        this.setState({profileSaveSuccess: '', profileSaveError: ''});
        api({
            url: GlobalVariable.host() + '/widget/profile/save',
            headers: {'Content-Type': 'application/json'},
            withCredentials: true,
            method: "POST",
            data
        }).then(() => {
            this.fetchProfile(false).then(() => {
                this.setState({activeSheet: '', profileSaveSuccess: 'Профиль сохранен'});
            });
        }).catch(() => {
            this.setState({profileSaveError: 'Не удалось сохранить профиль', auth: true, isLoad: true});
        });
    }

    exit() {
        api({
            url: GlobalVariable.host() + '/open/widget/v2/security/exit',
            headers: {'Content-Type': 'application/json'},
            withCredentials: true,
            method: "GET",
            data: {}
        }).then(() => {
            window.location.href = '/exit';
            this.setState({});
        }).catch(() => {
            this.setState({auth: false, isLoad: true});
        });
    }

    postDelProfile() {
        api({
            url: GlobalVariable.host() + '/widget/profile/delete',
            headers: {'Content-Type': 'application/json'},
            withCredentials: true,
            method: "GET",
            data: {}
        }).then(() => {
            window.location.href = '/home';
            this.setState({});
        }).catch(() => {
            this.setState({auth: false, isLoad: true});
        });
    }

    openDelBlock() { this.setState({openChangePoint: true}); }
    openExit() { this.setState({openExit: true, activeSheet: 'exit'}); }

    renderChooseExitProfile() {
        if (this.state.openExit === true) {
            return (
                <div className={'changePointBlock'}>
                    <div className={'changePoint'}>
                        <div>Вы действительно хотите выйти?</div>
                        <div onClick={() => this.exit()} className={'btn-active mt-3 mb-3'}>ДА</div>
                        <div onClick={() => this.setState({openExit: false})} className={'btn-active mt-3 mb-3'}>НЕТ</div>
                    </div>
                </div>
            );
        }
    }
    renderChooseDelProfile() {
        if (this.state.openChangePoint === true) {
            return (
                <div className={'changePointBlock'}>
                    <div className={'changePoint'}>
                        <div>Вы действительно хотите удалить свой профиль? (Все ваши баллы удалятся)</div>
                        <div onClick={() => this.postDelProfile()} className={'btn-active mt-3 mb-3'}>ДА</div>
                        <div onClick={() => this.setState({openChangePoint: false})} className={'btn-active mt-3 mb-3'}>НЕТ</div>
                    </div>
                </div>
            );
        }
    }

    private validateAvatar(file: File): string | null {
        const maxSizeMb = 5;
        const validTypes = ['image/jpeg','image/jpg','image/png','image/webp','image/heic','image/heif'];
        if (!validTypes.includes(file.type)) return 'Поддерживаются JPG, PNG, WEBP, HEIC.';
        if (file.size > maxSizeMb * 1024 * 1024) return `Размер до ${maxSizeMb} МБ.`;
        return null;
    }

    private async downscaleIfNeeded(file: File): Promise<Blob> {
        return new Promise((resolve) => {
            const img = new Image();
            img.onload = () => {
                const maxDim = 2048;
                const {width, height} = img;
                const needScale = Math.max(width, height) > maxDim;
                if (!needScale) { resolve(file); return; }
                const ratio = width > height ? maxDim / width : maxDim / height;
                const canvas = document.createElement('canvas');
                canvas.width = Math.round(width * ratio);
                canvas.height = Math.round(height * ratio);
                const ctx = canvas.getContext('2d');
                if (!ctx) { resolve(file); return; }
                ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
                canvas.toBlob((blob) => { resolve(blob || file); }, 'image/jpeg', 0.88);
            };
            img.onerror = () => resolve(file);
            img.src = URL.createObjectURL(file);
        });
    }

    async onAvatarSelect(e: React.ChangeEvent<HTMLInputElement>) {
        const f = e.target.files?.[0];
        if (!f) return;
        const err = this.validateAvatar(f);
        if (err) { this.setState({avatarError: err}); return; }
        const preview = URL.createObjectURL(f);
        this.setState({ avatarFile: f, avatarPreviewUrl: preview, avatarError: '' });
    }

    async uploadAvatar() {
        if (!this.state.avatarFile) return;
        this.setState({ avatarUploading: true, avatarProgress: 0, avatarError: '' });
        try {
            const hintedUrl =
                this.state?.info?.avatarUploadUrl ||
                this.state?.info?.avatar_upload_url ||
                this.state?.info?.avatarApiUrl ||
                this.state?.info?.avatar_api_url || null;

            const endpoint = hintedUrl || (GlobalVariable.staffBack() + '/mobile/profile/avatar');
            const method = this.state?.info?.avatarUploadMethod || 'POST';

            const blob = await this.downscaleIfNeeded(this.state.avatarFile);
            const form = new FormData();
            form.append('avatar', blob, this.state.avatarFile.name);
            form.append('file', blob, this.state.avatarFile.name);

            await api({
                url: endpoint, method, data: form, withCredentials: true, headers: {},
                onUploadProgress: (p: ProgressEvent) => {
                    if (p.total) this.setState({avatarProgress: Math.round((p.loaded / p.total) * 100)});
                }
            });

            await this.fetchProfile(true);
            this.setState({ avatarFile: null, avatarUploading: false });
        } catch (e) {
            if ((e as any)?.response?.status === 404) {
                try {
                    const legacyUrl = GlobalVariable.host() + '/mobile/profile/avatar/upload';
                    const blob = await this.downscaleIfNeeded(this.state.avatarFile as File);
                    const form = new FormData();
                    form.append('avatar', blob, (this.state.avatarFile as File).name);
                    await api({
                        url: legacyUrl, method: 'POST', data: form, withCredentials: true,
                        onUploadProgress: (p: ProgressEvent) => {
                            if (p.total) this.setState({avatarProgress: Math.round((p.loaded / p.total) * 100)});
                        }
                    });
                    await this.fetchProfile(true);
                    this.setState({ avatarFile: null, avatarUploading: false });
                    return;
                } catch {
                    this.setState({ avatarUploading: false, avatarError: 'Ошибка загрузки аватара.' });
                    return;
                }
            }
            this.setState({ avatarUploading: false, avatarError: 'Ошибка загрузки аватара.' });
        }
    }

    async removeAvatar() {
        this.setState({ avatarUploading: true, avatarError: '' });
        try {
            await api({ url: GlobalVariable.staffBack() + '/mobile/profile/avatar', method: 'DELETE', withCredentials: true });
        } catch {
            try {
                await api({ url: GlobalVariable.staffBack() + '/mobile/profile/avatar/delete', method: 'GET', withCredentials: true });
            } catch {
                this.setState({ avatarUploading: false, avatarError: 'Не удалось удалить аватар.' });
                return;
            }
        }
        await this.fetchProfile(true);
        this.setState({ avatarPreviewUrl: '', avatarUploading: false });
    }

    /** Быстрый запрос только аватара */
    private async fetchAvatarQuick() {
        try {
            const r = await api({
                url: GlobalVariable.staffBack() + '/mobile/profile/avatar/',
                method: 'GET',
                withCredentials: true,
                headers: {'Accept': 'application/json'}
            });
            const url = r?.data?.avatarAbsoluteUrl || r?.data?.avatarAbsoluteUrl || '';
            if (url) this.setState({ avatarUrl: url });
        } catch {}
    }

    private async fetchProfile(updateAvatarOnly = false) {
        try {
            const result = await api({
                url: GlobalVariable.host() + '/widget/profile/show',
                headers: {'Content-Type': 'application/json'},
                withCredentials: true,
                method: "GET",
            });
            const data = result.data || {};
            const avatarUrl =
                data.avatarUrl || data.avatar_url || data.avatar || data.photo || data.image || this.state.avatarUrl || '';

            if (updateAvatarOnly) {
                this.setState({ avatarUrl, info: data });
                return;
            }

            this.setState({
                name: data.name || '',
                date: data.date || '',
                email: data.email || '',
                isLoad: true,
                auth: true,
                profileLoadError: '',
                info: data,
                genderM: Number(data.sex) === 1,
                genderG: Number(data.sex) === 2,
                avatarUrl
            });
        } catch {
            this.setState({
                auth: false,
                isLoad: true,
                profileLoadError: 'Не удалось загрузить часть данных профиля',
            });
            // window.location.href = '/login';
        }
    }

    // =====================
    // ЛОГИКА РОЛЕЙ (новые роли с id.chio-chio.ru/api/roles)
    // =====================

    private async fetchUserRoles() {
        const idpOrigin = process.env.REACT_APP_IDP_ORIGIN || '';
        try {
            this.setState({ rolesLoading: true });

            const response = await api({
                url: `${idpOrigin}/api/roles`,
                method: 'GET',
                withCredentials: true,
                headers: { 'Content-Type': 'application/json' },
            });

            const data: RolesResponse = response.data;

            if (data && Array.isArray(data.roles)) {
                this.setState({ userRoles: buildRoleList(data.roles) });
            }
        } catch (error) {
            console.error('fetchUserRoles error:', error);

            this.setState({ userRoles: buildRoleList([]) });
        } finally {
            this.setState({ rolesLoading: false });
        }
    }

    private async fetchMobileProfile() {
        try {
            const profile = await api({
                url: GlobalVariable.host() + '/widget/staff/v2/profile',
                headers: {'Content-Type': 'application/json'},
                withCredentials: true,
                method: 'GET',
            });
            this.setState({mobileProfile: profile.data, isLoad: true, profileLoadError: ''});
        } catch {}

        try {
            const rating = await api({
                url: GlobalVariable.host() + '/widget/staff/v2/profile/rating',
                headers: {'Content-Type': 'application/json'},
                withCredentials: true,
                method: 'GET',
            });
            this.setState({rating: rating.data});
        } catch {}
    }

    private async markOnboardingShown() {
        try {
            await api({
                url: GlobalVariable.host() + '/widget/staff/v2/profile/onboarding-shown',
                headers: {'Content-Type': 'application/json'},
                withCredentials: true,
                method: 'POST',
                data: {},
            });
            this.setState({
                mobileProfile: {
                    ...this.state.mobileProfile,
                    onboarding: {
                        ...(this.state.mobileProfile?.onboarding || {}),
                        shown: true,
                    },
                },
            });
        } catch {}
    }

    private async sendServiceExpansionRequest() {
        if (!this.state.serviceRequestText.trim()) {
            return;
        }
        try {
            await api({
                url: GlobalVariable.host() + '/widget/staff/v2/profile/service-expansion-request',
                headers: {'Content-Type': 'application/json'},
                withCredentials: true,
                method: 'POST',
                data: {text: this.state.serviceRequestText},
            });
            this.setState({serviceRequestText: '', serviceRequestSuccess: 'Запрос отправлен партнеру'});
        } catch {
            this.setState({serviceRequestSuccess: 'Не удалось отправить запрос'});
        }
    }

    private handleRoleSelect(roleCode: string) {
        this.setState({ isRoleModalOpen: false });
        window.location.replace(resolveRoleTarget(roleCode, getAppTargets()));
    }

    private async handleRefreshRoles() {
        if (this.state.rolesLoading || this.state.rolesRefreshing) return;

        try {
            this.setState({ rolesRefreshing: true });
            const data = await refreshRolesJwtRequest();
            if (data && Array.isArray(data.roles)) {
                this.setState({
                    userRoles: buildRoleList(data.roles),
                });
            }
        } catch (error) {
            console.error('refreshRolesJwt error:', error);
        } finally {
            this.setState({ rolesRefreshing: false });
        }
    }

    private openRoleModal() {
        this.setState({ isRoleModalOpen: true, activeSheet: 'roles' });
    }

    private closeRoleModal() {
        this.setState({ isRoleModalOpen: false, activeSheet: '' });
    }

    private getSwitchableRoles(): UserRole[] {
        return (this.state.userRoles || []).filter(
            (role: UserRole) => role.hasRole && !CURRENT_APP_ROLE_CODES.includes(role.code)
        );
    }

    private initials(value: string): string {
        const parts = String(value || '').trim().split(/\s+/).filter(Boolean);
        if (!parts.length) return 'ЧЧ';
        if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
        return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
    }

    private handleAvatarImageError = () => {
        this.setState({ avatarPreviewUrl: '', avatarUrl: '' });
    };

    private experienceLabel(years: any): string {
        const total = Math.max(0, Number(years || 0));
        return `${total} г.`;
    }

    private getProfileData() {
        const profile = this.state.mobileProfile || {};
        const staff = profile.staff || {};
        const info = this.state.info || {};
        const name = staff.name || this.state.name || info.name || 'Мастер';
        const phone = staff.phone || info.phone || info.client || '';
        const grade = staff.gradeLabel || staff.profession || 'Мастер';
        const services = Array.isArray(staff.services) ? staff.services : [];
        return {
            profile,
            staff,
            info,
            name,
            phone,
            grade,
            services,
            avatar: this.state.avatarPreviewUrl || this.state.avatarUrl || '',
            experience: this.experienceLabel(staff.experience || 0),
            birthDate: staff.birthDate || this.state.date || '',
            mentor: profile.mentor || null,
            company: staff.company || this.state.rating?.company || {},
        };
    }

    private openSheet(sheet: string) {
        this.setState({activeSheet: sheet});
    }

    private closeSheet = () => {
        this.setState({
            activeSheet: '',
            openExit: false,
            isRoleModalOpen: false,
            profileSaveError: '',
            serviceRequestSuccess: this.state.activeSheet === 'services' ? this.state.serviceRequestSuccess : '',
        });
    };

    async componentDidMount() {
        this.fetchAvatarQuick();
        await Promise.all([
            this.fetchProfile(false),
            this.fetchMobileProfile(),
            this.fetchUserRoles(),
        ]);
    }

    private renderAvatarUploader() {
        const preview = this.state.avatarPreviewUrl || this.state.avatarUrl || '';
        const uploading = this.state.avatarUploading;
        const progress = this.state.avatarProgress;
        const hasLocalFile = !!this.state.avatarFile;

        return (
            <div className='profile-edit-avatar'>
	                <div className='profile-edit-avatar-preview'>
	                        {preview ? (
	                            <img src={preview} alt='avatar'
	                                 onError={this.handleAvatarImageError}
	                                 style={{width: '100%', height: '100%', objectFit: 'cover'}}/>
	                        ) : (
	                            <div className='profile-avatar-empty'>{this.initials(this.state.name)}</div>
                        )}
                </div>

                <div className='profile-edit-avatar-actions'>
                    <input ref={this.fileInputRef} type='file' accept='image/*' capture='user'
                           onChange={this.onAvatarSelect} style={{display: 'none'}}/>
                    <button type='button' onClick={() => this.fileInputRef.current?.click()} className='profile-secondary-button'>Выбрать фото</button>
                    <button type='button' onClick={hasLocalFile && !uploading ? this.uploadAvatar : undefined}
                            disabled={!hasLocalFile || uploading}
                            className='profile-primary-button'>
                        {uploading ? 'Загрузка...' : 'Загрузить'}
                    </button>

                    <div className='profile-hint'>JPG, PNG, WEBP или HEIC до 5 МБ</div>

                    {uploading && (
                        <div className='profile-upload-progress'>
                            <span>{progress}%</span>
                            <div><i style={{width: `${progress}%`}}/></div>
                        </div>
                    )}

                    {preview && !uploading && (
                        <button type='button' onClick={this.removeAvatar} className='profile-link-button danger'>Удалить фото</button>
                    )}

                    {this.state.avatarError && (
                        <div className='profile-alert danger'>{this.state.avatarError}</div>
                    )}
                </div>
            </div>
        );
    }

    private renderSheet(title: string, children: React.ReactNode, className = '') {
        return (
            <div className='profile-sheet-overlay' role='dialog' aria-modal='true' onClick={this.closeSheet}>
                <div className={`profile-sheet ${className}`} onClick={(event) => event.stopPropagation()}>
                    <div className='profile-sheet-handle'/>
                    <div className='profile-sheet-head'>
                        <h2>{title}</h2>
                        <button type='button' onClick={this.closeSheet} aria-label='Закрыть'>×</button>
                    </div>
                    {children}
                </div>
            </div>
        );
    }

    private renderEditSheet() {
        if (this.state.activeSheet !== 'edit') return null;
        const gender = this.state.genderM || this.state.genderG;
        const canSave = this.state.name && this.state.date && gender;

        return this.renderSheet('Редактировать профиль', (
            <div className='profile-form'>
                {this.renderAvatarUploader()}
                <label>
                    <span>Имя</span>
                    <input value={this.state.name} placeholder='Имя' onChange={this.changeName}/>
                </label>
                <label>
                    <span>Дата рождения</span>
                    <input type='date' value={this.state.date} onChange={this.changeDate}/>
                </label>
                <div className='profile-radio-row'>
                    <button type='button' className={this.state.genderM ? 'active' : ''} onClick={() => this.setState({genderM: true, genderG: false})}>Мужской</button>
                    <button type='button' className={this.state.genderG ? 'active' : ''} onClick={() => this.setState({genderM: false, genderG: true})}>Женский</button>
                </div>
                <label>
                    <span>Email</span>
                    <input value={this.state.email} placeholder='Email' onChange={this.changeEmail}/>
                </label>
                {this.state.profileSaveError ? <div className='profile-alert danger'>{this.state.profileSaveError}</div> : null}
                <button type='button' className='profile-primary-button wide' disabled={!canSave} onClick={() => this.sender()}>
                    Сохранить
                </button>
            </div>
        ), 'profile-edit-sheet');
    }

    private renderServicesSheet() {
        if (this.state.activeSheet !== 'services') return null;
        const data = this.getProfileData();

        return this.renderSheet('Услуги', (
            <div className='profile-services-sheet'>
                <div className='profile-chip-list'>
                    {data.services.length ? data.services.map((item: any) => (
                        <span key={item.id || item.title}>{item.title}</span>
                    )) : <em>Услуги не указаны</em>}
                </div>
                <label className='profile-textarea-label'>
                    <span>Запрос на расширение перечня</span>
                    <textarea
                        placeholder='Какие услуги хотите добавить?'
                        value={this.state.serviceRequestText}
                        onChange={(event) => this.setState({serviceRequestText: event.target.value})}
                    />
                </label>
                {this.state.serviceRequestSuccess ? (
                    <div className='profile-alert'>{this.state.serviceRequestSuccess}</div>
                ) : null}
                <button type='button' className='profile-primary-button wide' onClick={() => this.sendServiceExpansionRequest()} disabled={!this.state.serviceRequestText.trim()}>
                    Отправить запрос
                </button>
            </div>
        ));
    }

    private renderRatingSheet() {
        if (this.state.activeSheet !== 'rating') return null;
        const rating = this.state.rating || {};
        const rows = (rating.top || []).slice(0, 10);

        return this.renderSheet('Рейтинг салона', (
            <div className='profile-rating-list sheet-list'>
                {rating.current ? (
                    <div className='profile-current-rank'>
                        <span>Ваше место</span>
                        <strong>{rating.current.rank}</strong>
                    </div>
                ) : null}
                {rows.length ? rows.map((row: any) => (
                    <div className={`profile-rating-row ${row.isCurrent ? 'is-current' : ''}`} key={row.staffId || row.rank}>
                        <span>{row.rank}</span>
                        <strong>{row.staffName}</strong>
                        <em>{row.recordsCount || 0} чеков</em>
                    </div>
                )) : <div className='profile-empty'>Рейтинг пока не сформирован</div>}
            </div>
        ));
    }

    private renderRoleSelectModal() {
        if (this.state.activeSheet !== 'roles') return null;
        const availableRoles = this.getSwitchableRoles();

        return this.renderSheet('Роли', (
            <div className='profile-role-list sheet-list'>
                <button type='button' onClick={() => this.handleRoleSelect(CURRENT_APP_ACTION_CODE)}>
                    <strong>{CURRENT_APP_STAY_LABEL}</strong>
                    <span>Текущий кабинет</span>
                </button>
                {availableRoles.length ? availableRoles.map((role) => (
                    <button type='button' key={role.code} onClick={() => this.handleRoleSelect(role.code)}>
                        <strong>{role.name}</strong>
                        <span>{role.code}</span>
                    </button>
                )) : (
                    <div className='profile-empty'>Других ролей пока нет</div>
                )}
                <button type='button' className='profile-refresh-role' onClick={this.handleRefreshRoles}>
                    <strong>{this.state.rolesRefreshing ? 'Обновляем...' : 'Обновить роли'}</strong>
                    <span>Запросить актуальные роли из ID</span>
                </button>
            </div>
        ));
    }

    private renderExitSheet() {
        if (this.state.activeSheet !== 'exit') return null;

        return this.renderSheet('Выход', (
            <div className='profile-exit-sheet'>
                <p>Вы действительно хотите выйти из приложения?</p>
                <button type='button' className='profile-primary-button wide danger' onClick={() => this.exit()}>Выйти</button>
                <button type='button' className='profile-secondary-button wide' onClick={this.closeSheet}>Остаться</button>
            </div>
        ));
    }

    private renderAlerts() {
        const data = this.getProfileData();
        const profile = data.profile;
        const alerts: React.ReactNode[] = [];
        if (this.state.profileLoadError) {
            alerts.push(
                <div className='profile-banner danger' key='profile-load'>
                    <div><strong>Профиль открыт</strong><span>{this.state.profileLoadError}</span></div>
                </div>
            );
        }
        if (profile && profile.onboarding && !profile.onboarding.shown) {
            alerts.push(
                <div className='profile-banner' key='onboarding'>
                    <div><strong>Добро пожаловать</strong><span>{profile.onboarding.text}</span></div>
                    <button type='button' onClick={() => this.markOnboardingShown()}>Понятно</button>
                </div>
            );
        }
        if (profile?.birthdayGift?.available) {
            alerts.push(
                <div className='profile-banner accent' key='birthday'>
                    <div><strong>Подарок ко дню рождения</strong><span>+50 Чикоинов начисляются раз в год</span></div>
                </div>
            );
        }
        if (profile?.exitInterview?.required) {
            alerts.push(
                <a className='profile-banner danger' href={profile.exitInterview.url} target='_blank' rel='noopener noreferrer' key='exit'>
                    <div><strong>Exit interview</strong><span>Пожалуйста, пройдите короткую анкету</span></div>
                </a>
            );
        }

        return alerts.length ? <div className='profile-alerts'>{alerts}</div> : null;
    }

    render() {
        if (!this.state.isLoad) return (<Preloader />);
        const data = this.getProfileData();
        const rating = this.state.rating || {};
        const ratingRows = (rating.top || []).slice(0, 3);
        const roleCount = this.getSwitchableRoles().length;
        const bookUrl = data.profile.employeeBookUrl;
        const appVersion = process.env.REACT_APP_VERSION || '3.0.16';

        return (
            <div className='main profile profile-redesign'>
                <div className='profile-v2-content'>
                    <section className='profile-hero'>
                        <a href='/' className='profile-back' aria-label='На главную'>‹</a>
	                        <button type='button' className='profile-edit-top' onClick={() => this.openSheet('edit')}>Изменить</button>
	                        <div className='profile-avatar'>
	                            {data.avatar ? (
	                                <img src={data.avatar} alt={data.name} onError={this.handleAvatarImageError}/>
	                            ) : (
	                                <span>{this.initials(data.name)}</span>
	                            )}
	                        </div>
                        <h1>{data.name}</h1>
                        <p>{data.grade}</p>
                        <div className='profile-hero-stats'>
                            <span><strong>{data.experience}</strong><em>стаж</em></span>
                            <span><strong>{data.phone || 'не указан'}</strong><em>телефон</em></span>
                        </div>
                    </section>

                    <section className='profile-quick-actions' aria-label='Быстрые действия'>
                        <button type='button' onClick={() => this.openSheet('services')}>
                            <span><img src='/img/profile-v2/services.svg' alt=''/></span><strong>Услуги</strong>
                        </button>
                        {bookUrl ? (
                            <a href={bookUrl} target='_blank' rel='noopener noreferrer'>
                                <span><img src='/img/profile-v2/book.svg' alt=''/></span><strong>Книга</strong>
                            </a>
                        ) : (
                            <button type='button' disabled>
                                <span><img src='/img/profile-v2/book.svg' alt=''/></span><strong>Книга</strong>
                            </button>
                        )}
                        <button type='button' onClick={this.openRoleModal}>
                            <span><img src='/img/profile-v2/roles.svg' alt=''/></span><strong>{roleCount ? `Роли ${roleCount}` : 'Роли'}</strong>
                        </button>
                        <button type='button' onClick={() => this.openSheet('exit')}>
                            <span><img src='/img/profile-v2/logout.svg' alt=''/></span><strong>Выход</strong>
                        </button>
                    </section>

                    {this.renderAlerts()}

                    <section className='profile-card profile-work-card'>
                        <div className='profile-section-head'>
                            <h2>Рабочий профиль</h2>
                            {data.profile.newMaster ? <span>Новичок</span> : null}
                        </div>
                        <div className='profile-info-grid'>
                            <div><span>Грейд</span><strong>{data.grade}</strong></div>
                            <div><span>Стаж</span><strong>{data.experience}</strong></div>
                            <div><span>Дата рождения</span><strong>{data.birthDate || 'не указана'}</strong></div>
                            <div><span>Салон</span><strong>{data.company.address || data.company.title || 'не указан'}</strong></div>
                        </div>
                        {data.mentor ? (
                            <div className='profile-mentor'>
                                <span>Наставник</span>
                                <strong>{data.mentor.name || data.mentor.phone}</strong>
                                {data.mentor.phone ? <em>{data.mentor.phone}</em> : null}
                            </div>
                        ) : null}
                    </section>

                    <section className='profile-card profile-services-card'>
                        <div className='profile-section-head'>
                            <h2>Услуги</h2>
                            <button type='button' onClick={() => this.openSheet('services')}>Запросить</button>
                        </div>
                        <div className='profile-chip-list'>
                            {data.services.length ? data.services.slice(0, 8).map((item: any) => (
                                <span key={item.id || item.title}>{item.title}</span>
                            )) : <em>Услуги не указаны</em>}
                        </div>
                    </section>

                    <section className='profile-card profile-rating-card'>
                        <div className='profile-section-head'>
                            <h2>Рейтинг салона</h2>
                            <button type='button' onClick={() => this.openSheet('rating')}>Топ-10</button>
                        </div>
                        {rating.current ? (
                            <div className='profile-rank-summary'>
                                <span>Ваше место</span><strong>{rating.current.rank}</strong>
                            </div>
                        ) : <div className='profile-empty'>Место появится после первых оплат</div>}
                        {ratingRows.map((row: any) => (
                            <div className={`profile-rating-row ${row.isCurrent ? 'is-current' : ''}`} key={row.staffId || row.rank}>
                                <span>{row.rank}</span><strong>{row.staffName}</strong><em>{row.recordsCount || 0} чеков</em>
                            </div>
                        ))}
                    </section>

                    <section className='profile-card profile-app-card'>
                        <div className='profile-section-head'>
                            <h2>Приложение</h2>
                            <span>{appVersion}</span>
                        </div>
                        <button type='button' onClick={this.handleRefreshRoles} className='profile-row-button'>
                            <strong>{this.state.rolesRefreshing ? 'Обновляем роли...' : 'Обновить роли'}</strong>
                            <span>Синхронизация с ID</span>
                        </button>
                        <button type='button' onClick={() => this.openSheet('exit')} className='profile-row-button danger'>
                            <strong>Выйти</strong>
                            <span>Завершить текущую сессию</span>
                        </button>
                    </section>
                </div>

                <Menu/>
                {this.renderEditSheet()}
                {this.renderServicesSheet()}
                {this.renderRatingSheet()}
                {this.renderRoleSelectModal()}
                {this.renderExitSheet()}
            </div>
        );
    }
}

export default ProfileChange;
